<template>
    <div>
        <div
            class="mb-3 flex border rounded transition-colors duration-300"
            :class="{
            'border-gray-400': !focused,
            'border-gray-600': focused,
            'border-red-500': isInvalid,
            'border-green-500': isSuccess,
            'bg-gray-200 opacity-70': disabled,
        }"
        >
            <div
                v-if="prefix"
                class="flex-none flex justify-center items-center px-3 pt-5 pb-1 border-r border-gray-300 text-gray-400"
                @click.prevent="setFocus()"
            >
                {{ prefix }}
            </div>
            <div
                class="relative w-full flex-1"
            >
                <slot name="label">
                    <label
                        class="text-xs inline-block clear-both py-0 transition-colors duration-300 absolute m-1 top-0 left-0 right-0 flex justify-between z-10"
                        @click.prevent="setFocus()"
                        :class="{
                            'text-gray-400': !focused,
                            'text-gray-700': focused,
                            'text-red-500': isInvalid,
                            'text-green-500': isSuccess,
                        }"
                    >
                        <span>
                            {{ label }}
                            <span v-if="required" class="text-red-500 font-bold">
                                *
                            </span>
                        </span>
                        <span class="w-5">
                            <XIcon v-if="isInvalid" />
                            <CheckIcon v-if="isSuccess" />
                        </span>
                    </label>
                </slot>
                <div class="mt-5 mb-1 mx-1 flex">
                    <span class="flex-1">
                        <slot />
                    </span>
                    <span v-if="$slots.icon" class="flex-initial flex items-center ml-1">
                        <slot name="icon" />
                    </span>
                </div>

            </div>
            <div
                v-if="suffix"
                class="flex-none flex justify-center items-center px-3 pt-5 pb-1 border-l border-gray-300 text-gray-400"
                @click.prevent="setFocus()"
            >
                {{ suffix }}
            </div>
        </div>
        <div v-if="isInvalid" class="bg-red-500 text-white py-1 px-2 text-sm rounded -mt-2 relative z-20 shadow-lg mb-2">
            <div class="absolute arrow-up"></div>
            <slot name="invalid-message" />
        </div>
    </div>
</template>

<script>
import {CheckIcon, XIcon} from '@heroicons/vue/solid';

export default {
    name: "FormComponent",
    emits: ['focus'],
    components: {
        CheckIcon,
        XIcon,
    },
    props: {
        label: String,
        labelInset: Boolean,
        prefix: String,
        suffix: String,
        focused: Boolean,
        required: Boolean,
        isInvalid: Boolean,
        isSuccess: Boolean,
        disabled: Boolean,
    },
    setup (props, {emit}) {
        const setFocus = (e) => {
            emit('focus', e);
        }

        return {
            setFocus,
        }
    },
}
</script>

<style scoped>

</style>
